/**
 * @readonly
 * @enum {string}
 */
export const EvFuelTypes = Object.freeze({
    NONELECTRIC: 'NONELECTRIC',
    ELECTRIC: 'ELECTRIC',
    PHEV: 'PHEV',
    UNKNOWN: 'UNKNOWN'
})
